import { Capacitor } from '@capacitor/core';

/**
 * Capacitorネイティブアプリ上で動作しているかを判定する
 */
export const isNativeApp = (): boolean => {
  return Capacitor.isNativePlatform();
};

/**
 * 現在のプラットフォームを取得する ('web' | 'ios' | 'android')
 */
export const getPlatform = (): string => {
  return Capacitor.getPlatform();
};

/**
 * iOSネイティブアプリかどうかを判定する
 */
export const isIOS = (): boolean => {
  return Capacitor.getPlatform() === 'ios';
};
